import { render, staticRenderFns } from "./MailingTemplateCard.vue?vue&type=template&id=f63d2f9a&scoped=true&"
import script from "./MailingTemplateCard.vue?vue&type=script&lang=js&"
export * from "./MailingTemplateCard.vue?vue&type=script&lang=js&"
import style0 from "./MailingTemplateCard.vue?vue&type=style&index=0&id=f63d2f9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63d2f9a",
  null
  
)

export default component.exports